module.exports = __webpack_public_path__ + "static/img/pan.100ca45f.webp";